import React from 'react';
import { ErrorBoundary, SessionTimeoutModal } from '@vz/react-util';
import Router from './router';
import { GlobalStyle } from './App.styles';
import useIframeBridge from './shared/hooks/useIframeBridge';

const App = ({ vzgptEnabled, iframeId }) => {
  useIframeBridge(vzgptEnabled, iframeId);

  return (
    <ErrorBoundary>
      <GlobalStyle />
      <Router/>
      <SessionTimeoutModal />
    </ErrorBoundary>
  );
};

export default App;
